import { ConvertDateString } from '../dateformat/ConvertDateString'

export const CalculateDailyChestLogic = (value) => {
    let myObj = {
        ableToClaim: true,
        foodCount: value.monsterFoodCount,
        coins: value.studentCoins,
        onGoingChallengeCount: value.onGoingChallengeCount,
        onGoingSurveyCount: value.onGoingSurveyCount,
        onGoingCampaignCount: value.onGoingCampaignCount,
        currentDateTime: value.currentDateTime
    }

    if (value.dailyChestClaimDate != null && value.dailyChestClaimDate.length > 0) {
        let current = ConvertDateString.convertForDatePicker(value.currentDateTime);
        let today = new Date(current);
        today.setHours(0, 0, 0, 0)
        let claim = ConvertDateString.convertForDatePicker(value.dailyChestClaimDate);
        let lastClaimDate = new Date(claim);

        if (today.getDate() !== lastClaimDate.getDate()) {
            myObj.ableToClaim = true
        }
        else {
            myObj.ableToClaim = false;
        }
    }

    return myObj;
}